<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import videoComponent from "./production/video-component-production-tab.vue";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import InlineFileUploadVideo from "./uploads/InlineFileUploadVideo.vue";
import InlineFileUploadImage from "./uploads/InlineFileUploadImage.vue";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  name: "ProductionTab",
  data() {
    return {
      floppyDisk,
      openUploadModal: false,
      editImagePortrait: false,
      editImageLandscape: false,
      editVideoPortrait: false,
      editVideoLandscape: false,
      staticUsersOptions: [
        {
          value: "Sam Gowing",
          text: "Sam",
        },
        {
          value: "Xali",
          text: "Xali",
        },
        {
          value: "Naz",
          text: "Naz",
        },
        {
          value: "Guest",
          text: "Guest",
        },
      ],
    };
  },
  components: {
    InlineFileUploadVideo,
    InlineFileUploadImage,
    Multiselect,
    videoComponent,
  },
  computed: {
    ...mapGetters({
      currentActivity: "workouts/currentActivity",
      locationsOptions: "workouts/locationsOptions",
      reviewOptions: "workouts/reviewOptions",
      roughCutOptions: "workouts/roughCutOptions",
      finalCutOptions: "workouts/finalCutOptions",
      timerOptions: "workouts/timerOptions",
      colourGradeOptions: "workouts/colourGradeOptions",
      audioOptions: "workouts/audioOptions",
      render: "workouts/render",
      pre_production: "workouts/pre_production",
      post_production: "workouts/post_production",
      currentVideos: "workouts/currentVideos",
      userFieldOption: "workouts/userFieldOption",
    }),

    getRenderField() {
      return this.currentActivity.render
        ? "setActivityFieldObj"
        : "setActivityRenderField";
    },
    getPostProductionField() {
      return this.currentActivity.post_production
        ? "setActivityFieldObj"
        : "setActivityPostProductionField";
    },
    getPreProductionField() {
      return this.currentActivity.pre_production
        ? "setActivityFieldObj"
        : "setActivityPreProductionField";
    },

    location: {
      set(value) {
        this.$store.commit(`workouts/${this.getPreProductionField}`, {
          type: "pre_production",
          fieldName: "location",
          value,
        });
      },
      get() {
        if (this.currentActivity.pre_production) {
          return this.currentActivity.pre_production.location;
        }
        return this.pre_production.location;
      },
    },

    location_details: {
      set(value) {
        this.$store.commit(`workouts/${this.getPreProductionField}`, {
          type: "pre_production",
          fieldName: "location_details",
          value,
        });
      },
      get() {
        if (this.currentActivity.pre_production) {
          return this.currentActivity.pre_production.location_details;
        }
        return this.pre_production.location_details;
      },
    },

    location_details_state() {
      return this.currentActivity.pre_production.location_details != ""
        ? true
        : false;
    },

    wardrobe_and_hair: {
      set(value) {
        this.$store.commit(`workouts/${this.getPreProductionField}`, {
          type: "pre_production",
          fieldName: "wardrobe_and_hair",
          value,
        });
      },
      get() {
        if (this.currentActivity.pre_production) {
          return this.currentActivity.pre_production.wardrobe_and_hair;
        }
        return this.pre_production.wardrobe_and_hair;
      },
    },
    wardrobe_and_hair_state() {
      return this.currentActivity.pre_production.wardrobe_and_hair != ""
        ? true
        : false;
    },
    filming_notes: {
      set(value) {
        this.$store.commit(`workouts/${this.getPreProductionField}`, {
          type: "pre_production",
          fieldName: "filming_notes",
          value,
        });
      },
      get() {
        if (this.currentActivity.pre_production) {
          return this.currentActivity.pre_production.filming_notes;
        }
        return this.pre_production.filming_notes;
      },
    },
    filming_notes_state() {
      return this.currentActivity.pre_production.filming_notes != ""
        ? true
        : false;
    },

    assigned: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "assigned",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.assigned;
        }
        return this.post_production.assigned;
      },
    },
    ingest: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "ingest",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.ingest;
        }
        return this.post_production.ingest;
      },
    },
    rough_cut: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "rough_cut",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.rough_cut;
        }
        return this.post_production.rough_cut;
      },
    },
    review: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "review",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.review;
        }
        return this.post_production.review;
      },
    },
    final_cut: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "final_cut",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.final_cut;
        }
        return this.post_production.final_cut;
      },
    },
    audio: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "audio",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.audio;
        }
        return this.post_production.audio;
      },
    },
    colour_grade: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "colour_grade",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.colour_grade;
        }
        return this.post_production.colour_grade;
      },
    },
    timer: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "timer",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.timer;
        }
        return this.post_production.timer;
      },
    },
    file_location: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "file_location",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.file_location;
        }
        return this.post_production.file_location;
      },
    },
    file_location_state() {
      return this.currentActivity.pre_production.file_location != ""
        ? true
        : false;
    },
    project_location: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "project_location",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.project_location;
        }
        return this.post_production.project_location;
      },
    },

    project_location_state() {
      return this.currentActivity.pre_production.project_location != ""
        ? true
        : false;
    },

    edit_notes: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "edit_notes",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.edit_notes;
        }
        return this.post_production.edit_notes;
      },
    },

    portrait_video: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "portrait_video",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.portrait_video;
        }
        return this.post_production.portrait_video;
      },
    },

    landscape_video: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "landscape_video",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.landscape_video;
        }
        return this.post_production.landscape_video;
      },
    },

    portrait_thumbnail: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "portrait_thumbnail",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.portrait_thumbnail;
        }
        return this.post_production.portrait_thumbnail;
      },
    },

    landscape_thumbnail: {
      set(value) {
        this.$store.commit(`workouts/${this.getPostProductionField}`, {
          type: "post_production",
          fieldName: "landscape_thumbnail",
          value,
        });
      },
      get() {
        if (this.currentActivity.post_production) {
          return this.currentActivity.post_production.landscape_thumbnail;
        }
        return this.post_production.landscape_thumbnail;
      },
    },

    edit_notes_state() {
      return this.currentActivity.post_production.edit_notes != ""
        ? true
        : false;
    },
    title_card: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "title_card",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.title_card;
        }
        return this.render.title_card;
      },
    },

    rendered: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "rendered",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.rendered;
        }
        return this.render.rendered;
      },
    },

    uploaded: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "uploaded",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.uploaded;
        }
        return this.render.uploaded;
      },
    },

    txt_code: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "txt_code",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.txt_code;
        }
        return this.render.txt_code;
      },
    },

    render_file_location: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "file_location",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.file_location;
        }
        return this.render.file_location;
      },
    },

    brightcove_id: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "brightcove_id",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.brightcove_id;
        }
        return this.render.brightcove_id;
      },
    },

    thumbnail: {
      set(value) {
        this.$store.commit(`workouts/${this.getRenderField}`, {
          type: "render",
          fieldName: "thumbnail",
          value,
        });
      },
      get() {
        if (this.currentActivity.render) {
          return this.currentActivity.render.thumbnail;
        }
        return this.render.thumbnail;
      },
    },
  },

  methods: {
    update() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("workouts/updateProduction", this.$route.params.id)
        .then((res) => {
          this.$store
            .dispatch("workouts/updateVideo", this.$route.params.id)
            .then((res) => {
              this.$store.commit(`workouts/setEmptyPostProd`);
              this.$store
                .dispatch(`workouts/getActivity`, this.$route.params.id)
                .then((res) => {
                  this.tabStatus(false);
                  this.$store.commit(`commons/setSavingForm`, "Saved");
                  this.$store.commit("commons/setPreloader", false);
                });
            });
        });
    },

    // IMAGE PORTRAIT
    handleImagePortraitUploaded(file) {
      this.portrait_thumbnail = file;
      this.post_production.portrait_thumbnail = file;
      this.editImagePortrait = false;
    },
    editImagePortraitFunc() {
      this.editImagePortrait = true;
      this.portrait_thumbnail = null;
    },

    // IMAGE LANDSCAPE
    handleImageLandscapeUploaded(file) {
      this.landscape_thumbnail = file;
      this.post_production.landscape_thumbnail = file;
      this.editImageLandscape = false;
    },
    editImageLandscapeFunc() {
      this.editImageLandscape = true;
      this.landscape_thumbnail = null;
    },

    // VIDEO PORTRAIT
    handleVideoPortraitUploaded(file) {
      this.portrait_video = file;
      this.post_production.portrait_video = file;
      this.editVideoPortrait = false;
    },
    editVideoPortraitFunc() {
      this.editVideoPortrait = true;
      this.portrait_video = null;
    },

    // VIDEO LANDSCAPE
    handleVideoLandscapeUploaded(file) {
      this.landscape_video = file;
      this.post_production.landscape_video = file;
      this.editVideoLandscape = false;
    },
    editVideoLandscapeFunc() {
      this.editVideoLandscape = true;
      this.landscape_video = null;
    },

    tabStatus(status) {
      this.$store.commit(`workouts/setTabStatus`, status);
    },

    printPreview() {
      const activityType =
        this.currentActivity.type == "stretch_flow"
          ? "stretch-flow"
          : this.currentActivity.type;
      window.open(
        `#/printscript/${activityType}/${this.currentActivity.id}`,
        "_blank"
      );
    },
  },

  watch: {
    location_watch() {
      this.tabStatus(true);
    },
    location() {
      console.log();
      this.tabStatus(true);
    },
    location_details() {
      this.tabStatus(true);
    },
    wardrobe_and_hair() {
      this.tabStatus(true);
    },
    filming_notes() {
      this.tabStatus(true);
    },
    assigned() {
      this.tabStatus(true);
    },
    ingest() {
      this.tabStatus(true);
    },
    rough_cut() {
      this.tabStatus(true);
    },
    review() {
      this.tabStatus(true);
    },
    final_cut() {
      this.tabStatus(true);
    },
    audio() {
      this.tabStatus(true);
    },
    colour_grade() {
      this.tabStatus(true);
    },
    timer() {
      this.tabStatus(true);
    },
    file_location() {
      this.tabStatus(true);
    },
    project_location() {
      this.tabStatus(true);
    },
    edit_notes() {
      this.tabStatus(true);
    },
    portrait_thumbnail() {
      this.tabStatus(true);
    },
    landscape_thumbnail() {
      this.tabStatus(true);
    },
    portrait_video() {
      this.tabStatus(true);
    },
    landscape_video() {
      this.tabStatus(true);
    },
  },

  async mounted() {
    this.$store.dispatch(`workouts/getUsers`);
  },
};
</script>
<style lang="scss">
.wardrobe-wrapper {
  .form-group {
    width: calc(100% - 330px);
  }
  .thumbnail {
    border-radius: 4px;
    width: 300px;
    background: #d0d0d0;
    height: 155px;
    display: block;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
}

.custom-avatar {
  display: inline-block;
  background: #4d4d4d;
  color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  margin-right: 8px;
  vertical-align: middle;
  padding: 2px;
  line-height: 5px;
}
.video-wrapper {
  position: relative;
  .edit {
    background: rgba(63, 150, 152, 0.7);
    top: 40px;
    right: 20px;
    margin: auto;
    border: 0;
    border-radius: 50%;
    width: 40px;
    display: block;
    height: 40px;
    position: absolute;
  }
  .uppy-Dashboard-inner {
    height: 240px !important;
  }
}
</style>
<template>
  <div class="px-5 py-5">
    <b-form>
      <div class="container">
        <h2 class="mt-3">On Set</h2>
        <div class="row mt-5">
          <div class="col-md-6">
            <b-form-group label="LOCATION" label-for="location" class="select">
              <b-form-select
                :options="locationsOptions"
                id="location"
                v-model="location"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="LOCATION DETAILS" label-for="location_details">
              <b-form-input
                id="location_details"
                placeholder="Eg: Lorem Ipsum"
                v-model="location_details"
              ></b-form-input>
            </b-form-group>
          </div>

          <div
            class="col-md-12"
            :class="currentActivity.file ? 'wardrobe-wrapper' : ''"
          >
            <div
              :class="
                currentActivity.file ? 'd-flex justify-content-between' : ''
              "
            >
              <b-form-group
                label="WARDROBE & HAIR"
                label-for="wardrobe_and_hair"
              >
                <b-form-textarea
                  id="wardrobe_and_hair"
                  placeholder="Eg.: Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum."
                  rows="3"
                  max-rows="6"
                  v-model="wardrobe_and_hair"
                ></b-form-textarea>
              </b-form-group>

              <div
                class="thumbnail"
                v-if="currentActivity.landscape_thumbnail"
                :style="{
                  backgroundImage:
                    'url(\'' + currentActivity.landscape_thumbnail + '\')',
                }"
              ></div>
            </div>
          </div>
          <div class="col-md-12">
            <b-form-group label="FILMING NOTES" label-for="filming_notes">
              <b-form-textarea
                id="filming_notes"
                placeholder="Eg.: Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum."
                rows="3"
                max-rows="6"
                v-model="filming_notes"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>
      </div>
      <hr />
      <div class="container py-5">
        <h2>Post Production</h2>
        <div class="row mt-5">
          <div class="col-md-6">
            <label for="">ASSIGNED TO</label>
            <multiselect
              v-model="assigned"
              :options="userFieldOption"
              :close-on-select="false"
              :clear-on-select="false"
              :hide-selected="true"
              :searchable="true"
              label="text"
              track-by="text"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value">
                  <span class="custom-avatar"
                    ><b-icon icon="person-fill"></b-icon
                  ></span>
                  {{ value.text }}
                </div>
              </template>

              <template slot="option" slot-scope="{ option }">
                <div class="option-item">
                  <span class="custom-avatar"
                    ><b-icon icon="person-fill"></b-icon
                  ></span>
                  {{ option ? option.text : "" }}
                </div>
              </template>
            </multiselect>
          </div>
          <div class="col-md-6">
            <b-form-group label="INGEST" label-for="ingest">
              <b-form-checkbox v-model="ingest" switch class="mr-3">
                Ingest
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="ROUGH CUT"
              label-for="rough_cut"
              class="select"
            >
              <b-form-select
                v-model="rough_cut"
                :options="roughCutOptions"
                id="rough_cut"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="REVIEW" label-for="review" class="select">
              <b-form-select
                v-model="review"
                :options="reviewOptions"
                id="review"
              ></b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="FINAL CUT"
              label-for="final_cut"
              class="select"
            >
              <b-form-select
                v-model="final_cut"
                :options="finalCutOptions"
                id="review"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              label="COLOUR GRADE"
              label-for="colour_grade"
              class="select"
            >
              <b-form-select
                v-model="colour_grade"
                :options="colourGradeOptions"
                id="review"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="TIMER" label-for="timer" class="select">
              <b-form-select
                v-model="timer"
                :options="timerOptions"
                id="review"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="AUDIO" label-for="audio" class="select">
              <b-form-select
                v-model="audio"
                :options="audioOptions"
                id="audio"
              ></b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group label="PROJECT NAME" label-for="file_location">
              <b-form-input
                id="file_location"
                v-model="file_location"
                placeholder="Eg: ??????"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group label="PROJECT LOCATION" label-for="project_location">
              <b-form-input
                id="project_location"
                v-model="project_location"
                placeholder="Eg: ??????"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-form-group label="EDIT NOTES*" label-for="edit_notes">
              <b-form-textarea
                id="edit_notes"
                v-model="edit_notes"
                placeholder="Lorem Ipsum..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <div class="col-md-12 d-flex align-items-center my-3">
            <b-form-checkbox name="check-button" switch v-model="ingest">
              GRAPHICS
            </b-form-checkbox>
            <div class="pb-3 pl-4 pt-1">
              <b-icon icon="exclamation-circle"></b-icon>
              <span
                class="text-primary pl-2 cursor-pointer"
                @click="printPreview"
              >
                <b> VIEW SCRIPT</b></span
              >
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label for="uploader"> PORTRAIT THUMBNAIL</label>
            <div
              v-if="portrait_thumbnail && !editImagePortrait"
              class="mt-1 portrait image-wrapper"
              :style="{
                backgroundImage: 'url(\'' + portrait_thumbnail + '\')',
              }"
            >
              <div class="actions d-flex justify-content-end w-100 p-2">
                <div class="d-flex">
                  <span
                    @click="editImagePortraitFunc()"
                    class="
                      edit
                      mr-1
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <b-icon icon="pencil" />
                  </span>
                  <span
                    @click="$bvModal.show('portrait_thumbnail')"
                    class="
                      edit
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <b-icon icon="eye" />
                  </span>
                </div>
              </div>
            </div>
            <inline-file-upload-image
              v-if="!portrait_thumbnail || editImagePortrait"
              :allowMultipleUploads="false"
              v-on:file-uploaded="handleImagePortraitUploaded"
            >
            </inline-file-upload-image>
          </div>

          <div class="col-md-6 mb-3">
            <label for="uploader"> LANDSCAPE THUMBNAIL</label>
            <div
              v-if="landscape_thumbnail && !editImageLandscape"
              class="mt-1 portrait image-wrapper"
              :style="{
                backgroundImage: 'url(\'' + landscape_thumbnail + '\')',
              }"
            >
              <div class="actions d-flex justify-content-end w-100 p-2">
                <div class="d-flex">
                  <span
                    @click="editImageLandscapeFunc()"
                    class="
                      edit
                      mr-1
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <b-icon icon="pencil" />
                  </span>
                  <span
                    @click="$bvModal.show('landscape_thumbnail')"
                    class="
                      edit
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <b-icon icon="eye" />
                  </span>
                </div>
              </div>
            </div>
            <inline-file-upload-image
              v-if="!landscape_thumbnail || editImageLandscape"
              :allowMultipleUploads="false"
              v-on:file-uploaded="handleImageLandscapeUploaded"
            >
            </inline-file-upload-image>
          </div>

          <div class="video-wrapper col-md-6">
            <label for="uploader"> PORTRAIT VIDEO PREVIEW</label>
            <div v-if="portrait_video && !editVideoPortrait">
              <video style="width: 100%" height="340" controls>
                <source :src="portrait_video" type="video/mp4" />
                <source :src="portrait_video" type="video/ogg" />
                Your browser does not support the video tag.
              </video>
              <button @click="editVideoPortraitFunc()" class="edit">
                <b-icon icon="pencil" />
              </button>
            </div>
            <inline-file-upload-video
              v-if="!portrait_video || editVideoPortrait"
              :allowMultipleUploads="false"
              v-on:file-uploaded="handleVideoPortraitUploaded"
            >
            </inline-file-upload-video>
          </div>

          <div class="video-wrapper col-md-6">
            <label for="uploader"> LANDSCAPE VIDEO PREVIEW </label>
            <div v-if="landscape_video && !editVideoLandscape">
              <video style="width: 100%" height="340" controls>
                <source :src="landscape_video" type="video/mp4" />
                <source :src="landscape_video" type="video/ogg" />
                Your browser does not support the video tag.
              </video>
              <button @click="editVideoLandscapeFunc()" class="edit">
                <b-icon icon="pencil" />
              </button>
            </div>
            <inline-file-upload-video
              v-if="!landscape_video || editVideoLandscape"
              :allowMultipleUploads="false"
              v-on:file-uploaded="handleVideoLandscapeUploaded"
            >
            </inline-file-upload-video>
          </div>
        </div>
      </div>
      <hr />
      <div class="container py-5">
        <h2>Renders</h2>
        <div class="row mt-5">
          <div class="col-12">
            <video-component
              v-for="(video, index) of currentVideos"
              :key="index"
              :index="index"
              :video="video"
            >
            </video-component>
          </div>
        </div>
      </div>
    </b-form>
    <button class="floating-btn btn no-outline" @click="update()">
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
    <b-modal id="portrait_thumbnail" hide-header hide-footer>
      <div class="text-right close">
        <span @click="$bvModal.hide('portrait_thumbnail')" class="cursor-pointer h3"
          ><b-icon icon="x"
        /></span>
      </div>

      <img :src="portrait_thumbnail" class="w-100 mt-2" />
    </b-modal>
    <b-modal id="landscape_thumbnail" hide-header hide-footer>
      <div class="text-right close">
        <span @click="$bvModal.hide('image-viewer')" class="cursor-pointer h3"
          ><b-icon icon="x"
        /></span>
      </div>
      <img :src="landscape_thumbnail" class="w-100 mt-2" />
    </b-modal>
  </div>
</template>